export var INBOUND_TYPE;
(function (INBOUND_TYPE) {
    INBOUND_TYPE["\uBC1C\uC8FC\uB0B4\uC5ED"] = "\uBC1C\uC8FC\uB0B4\uC5ED";
    INBOUND_TYPE["\uC790\uC7AC\uC120\uD0DD"] = "\uC790\uC7AC\uC120\uD0DD";
    INBOUND_TYPE["\uC9C1\uC811\uC785\uB825"] = "\uC9C1\uC811\uC785\uB825";
    INBOUND_TYPE["\uCD9C\uACE0\uB0B4\uC5ED"] = "\uCD9C\uACE0\uB0B4\uC5ED";
    INBOUND_TYPE["\uBBF8\uAE30\uC7AC"] = "\uBBF8\uAE30\uC7AC";
    INBOUND_TYPE["\uAD6C\uB9E4\uC2E0\uCCAD"] = "\uAD6C\uB9E4\uC2E0\uCCAD";
})(INBOUND_TYPE || (INBOUND_TYPE = {}));
